import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Item } from '../items/items.model';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ItemsInFilterService {
  model = 'RPMItemsInFilter';
  constructor(private httpClient: HttpClient) {}
  getList(params = {}): Promise<HttpResponse<Item[]>> {
    
    // @ts-ignore
    // observe: 'response'
    return this.httpClient
      .get(this.model, { params, observe: 'response' })
      .pipe(timeout(environment.requestTimeout))
      .toPromise() as Promise<HttpResponse<Item[]>>;
  } 
}
